import React from 'react';
import { CombinedError } from 'urql';

import { useTranslation } from '@lyearn/i18n';
import { AlertTriangleOutline, SearchFill } from '@lyearn/icons';
import { EmptyState, SidebarEmptyState } from '@lyearn/molecules';
import { Stack } from '@lyearn/ui';
import { onRefresh } from '@/components/Error/utils';

type EmptyStateProps = {
  error?: CombinedError;
  search: string;
  clearSearch: () => void;
};

function EmptyStateComp(props: EmptyStateProps) {
  const { t } = useTranslation('Jira');
  const { error, search, clearSearch } = props;

  if (search.length) {
    return (
      <Stack alignItems="center" className="h-full p-32" direction="col" justifyContent="center">
        <EmptyState
          Icon={error ? AlertTriangleOutline : SearchFill}
          description={t('Jira:NoResultsSearchDescription')}
          primaryAction={{
            label: t('Common:EmptyState.ClearSearch'),
            onClick: clearSearch,
          }}
          title={error ? t('Jira:JQLQueryInvalid') : t('Jira:NoResultsSearch', { search })}
        />
      </Stack>
    );
  }

  return (
    <Stack alignItems="center" className="h-full p-32" direction="col" justifyContent="center">
      <SidebarEmptyState
        Icon={AlertTriangleOutline}
        description={t('Jira:JiraNetworkError')}
        primaryAction={{
          label: t('Common:Error.Reload'),
          onClick: onRefresh,
        }}
      />
    </Stack>
  );
}

export default EmptyStateComp;
